import { cn } from "@/lib/utils";

export function LoadingSpinner({ className }: { className?: string }) {
  return <div className={cn("animate-spin rounded-full border-b-2 border-gray-900", className)} />;
}
